import { useMutation } from "@apollo/client";

import {
  ConfirmBeneficiaryGiftingCodeMutation,
  ConfirmBeneficiaryGiftingCodeMutationVariables,
} from "@ctypes";
import { CONFIRM_BENEFICIARY_GIFTING_CODE } from "@graphql";

export const useConfirmBeneficiaryGiftingCode = () => {
  return useMutation<
    ConfirmBeneficiaryGiftingCodeMutation,
    ConfirmBeneficiaryGiftingCodeMutationVariables
  >(CONFIRM_BENEFICIARY_GIFTING_CODE);
};
